const API_URL = (process.env.NEXT_PUBLIC_API_URL ?? '').replace(/\/$/, '')

export async function postApi(path, body) {
  if (!API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not configured')
  }

  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  const payload = await response.json().catch(() => null)
  if (!response.ok) {
    throw new Error(payload?.error || 'Не удалось отправить заявку')
  }

  return payload
}
